<template>
  <div>
    <div class="url-list">
      <div v-if="urls.length === 0">.No URLs found in the file.</div>
      <div v-else>
        <div class="image-scroll-container">
          <div class="arrow left-arrow" @click="scrollLeft">‹</div>
          <div class="image-container" ref="imageContainer">
            <!-- Iterate over the URLs and display each image -->
            <img
              v-for="(url, index) in urlsWithHttp"
              :key="index"
              :src="url"
              alt="image"
              class="image-item"
              @click="enlargeImage(url)"
            />
          </div>
          <div class="arrow right-arrow" @click="scrollRight">›</div>
        </div>
      </div>
    </div>

    <!-- Modal for displaying enlarged image -->
    <div v-if="enlargedImage" class="modal" @click="closeModal">
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <img :src="enlargedImage" alt="Enlarged image" class="enlarged-image">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'arrayImage',
  props: {
    projectPath: {
      type: String,
      required: true
    },
    urls: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      enlargedImage: null // Store the URL of the currently enlarged image
    };
  },
  computed: {
    urlsWithHttp() {
      // Add "https://res.cloudinary.com/alvin-tan/image/upload/" prefix to each URL with thumbnail transformation
   //   return this.urls.map(url => `https://res.cloudinary.com/alvin-tan/image/upload/w_300,h_300/${this.projectPath}/${url}`);
      return this.urls.map(url =>  `https://res.cloudinary.com/alvin-tan/image/upload/c_auto,h_300/${this.projectPath}/${url}`);
// thumbnail      https://res.cloudinary.com/alvin-tan/image/upload/t_media_lib_thumb/vic/plez2zgntinqmh9td1od.png
    }
  },
  methods: {
    enlargeImage(url) {
      // Remove the thumbnail transformation for the enlarged image
      const fullSizeUrl = url.replace('upload/c_auto,h_300/', 'upload/');
      this.enlargedImage = fullSizeUrl; // Set the URL of the clicked image
    },
    closeModal() {
      this.enlargedImage = null; // Reset the enlarged image URL to close the modal
    },
    scrollLeft() {
      this.$refs.imageContainer.scrollBy({ left: -300, behavior: 'smooth' });
    },
    scrollRight() {
      this.$refs.imageContainer.scrollBy({ left: 300, behavior: 'smooth' });
    }
  }
};
</script>

<style scoped>
.url-list {
  margin-top: 20px;
  position: relative;
}

.image-scroll-container {
  overflow-x: auto;
  white-space: nowrap;
  position: relative;
  display: flex;
  align-items: center;
}

.image-container {
  display: inline-flex;
  overflow-x: auto;
  scroll-behavior: smooth;
}

.image-item {
  height: 300px;
  margin: 5px;
  object-fit: contain;
  cursor: pointer;
}

/* Arrow styles */
.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 2rem;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0.5rem;
  cursor: pointer;
  z-index: 1;
  user-select: none;
}

.left-arrow {
  left: 10px;
}

.right-arrow {
  right: 10px;
}

/* Modal styles */
.modal {
  display: flex;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  align-items: center;
  justify-content: center;
}

.modal-content {
  position: relative;
  background-color: white;
  padding: 20px;
  border-radius: 5px;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.enlarged-image {
  max-width: 100%;
  max-height: 100%;
}
</style>
